// extracted by mini-css-extract-plugin
module.exports = {"nav":"HeadBannerNav_nav_1Po9Z","locale":"HeadBannerNav_locale_2rqQL","install":"HeadBannerNav_install_1-CMe","prompt":"HeadBannerNav_prompt_3jqtV"};